import { css } from 'styled-components';
import { TBrandTone, tones } from '../../styles/brand';
import { TStatusTone } from '../../utils/tournament/status';

/** Qual cor da marca representa cada estado da feature de torneio. */
export const STATUS_TONE_COLOR: Record<TStatusTone, TBrandTone> = {
  plan: 'gray',
  open: 'blue',
  live: 'orange',
  done: 'green',
  off: 'red',
  alert: 'red',
};

export const softTone = (tone: TStatusTone) => {
  const color = tones[STATUS_TONE_COLOR[tone]];
  return css`
    background: ${color.soft};
    color: ${color.text};
  `;
};
